import { Fragment, useEffect, useState } from "react";
import { toast } from "sonner";
import { downloadFile } from "@/pages/admin/AdminInvoices";
import { api, eur } from "@/lib/api";

const STATUS = { pending: "Laukiama", cod: "Mokės pristačius", paid: "Apmokėta", shipped: "Išsiųsta", completed: "Įvykdyta", cancelled: "Atšaukta" };
const CLS = { pending: "text-amber-400", cod: "text-orange-400", paid: "text-emerald-400", shipped: "text-sky-400", completed: "text-slate-300", cancelled: "text-red-400" };

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(null);
  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (o, status) => {
    await api.patch(`/admin/orders/${o.id}`, { status });
    toast.success("Būsena atnaujinta");
    load();
  };

  return (
    <div data-testid="admin-orders" className="space-y-6">
      <h1 className="font-display font-black uppercase text-4xl tracking-tight">Užsakymai</h1>
      <div className="border border-[#3B4157] bg-[#292D3C] overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-orders-table">
          <thead><tr className="text-left text-slate-500 text-xs uppercase tracking-wider border-b border-[#3B4157]">
            <th className="p-3 pl-5">Nr.</th><th className="p-3">Data</th><th className="p-3">Klientas</th><th className="p-3 text-right">Suma</th><th className="p-3">Mokėjimas</th><th className="p-3 pr-5">Būsena</th>
          </tr></thead>
          <tbody>
            {orders.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-slate-500">Užsakymų dar nėra</td></tr>}
            {orders.map((o) => (
              <Fragment key={o.id}>
                <tr data-testid={`order-row-${o.id}`} onClick={() => setOpen(open === o.id ? null : o.id)} className="border-b border-[#3B4157] hover:bg-[#30354A] cursor-pointer">
                  <td className="p-3 pl-5 font-mono-x">{o.number}{o.made_to_order && <div data-testid={`order-made-to-order-${o.id}`} className="text-[10px] text-amber-400 uppercase tracking-wider font-sans">Pagal užklausą</div>}</td>
                  <td className="p-3 text-slate-400">{new Date(o.created_at).toLocaleString("lt-LT")}</td>
                  <td className="p-3">{o.customer.customer_type === "company" ? o.customer.company : o.customer.name}<div className="text-xs text-slate-500">{o.customer.customer_type === "company" ? "Įmonė · " : ""}{o.customer.email}</div></td>
                  <td className="p-3 text-right font-mono-x">{eur(o.total)} <span className="text-[10px] text-slate-500">{o.subtotal != null ? "su PVM" : ""}</span></td>
                  <td className="p-3 text-xs font-mono-x text-slate-400">{o.payment_method === "cod" ? "COD (pristačius)" : o.mode === "demo" ? "Paysera DEMO" : "Paysera"}<div>{o.transaction_id}</div>{o.invoice_number && <button data-testid={`order-invoice-${o.id}`} onClick={() => downloadFile(`/admin/invoices/${o.invoice_id}/pdf`, `${o.invoice_number}.pdf`)} className="text-orange-500 underline underline-offset-2">Sąskaita {o.invoice_number}</button>}</td>
                  <td className="p-3 pr-5" onClick={(e) => e.stopPropagation()}>
                    <select data-testid={`order-status-${o.id}`} value={o.status} onChange={(e) => setStatus(o, e.target.value)}
                      className={`h-8 bg-[#1F2230] border border-[#3B4157] px-2 text-xs ${CLS[o.status]}`}>
                      {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </td>
                </tr>
                {open === o.id && (
                  <tr className="bg-[#252937] border-b border-[#3B4157]">
                    <td colSpan={6} className="p-5 text-sm"><div className="grid sm:grid-cols-2 gap-6">
                      <div className="space-y-1">
                        {o.made_to_order && <div className="text-xs text-amber-400 uppercase tracking-wider">Pagal užklausą · pristatymas iki 14 d.</div>}
                        {o.items.map((i) => <div key={i.product_id}>{i.quantity} × {i.name} — <span className="font-mono-x">{eur(i.price * i.quantity)}</span>{i.options?.length > 0 && <div className="text-xs text-slate-500">+ {i.options.join(", ")}</div>}{i.backorder && <div className="text-xs text-amber-400">Nėra sandėlyje – užsakyti (pristatymas per 10 d.d.)</div>}</div>)}
                      </div>
                      <div className="text-slate-400 space-y-1">
                        {o.customer.customer_type === "company" && <div className="text-slate-200">{o.customer.company} · Įm. kodas: {o.customer.company_code}{o.customer.vat_code && ` · PVM: ${o.customer.vat_code}`} · Kontaktas: {o.customer.name}</div>}
                        <div>{o.customer.phone}</div>
                        <div>{o.customer.address}, {o.customer.city} {o.customer.postal_code}, {o.customer.country}</div>
                        {o.customer.notes && <div className="italic">„{o.customer.notes}“</div>}
                      </div>
                    </div></td>
                  </tr>
                )}
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
